<!--  -->
<template>
    <div class="questionnaire" v-loading="loading">
        <div v-if="data.photo">
            <img style="height: 40px;" :src="data.photo" >
        </div>
        <header class="questionnaire-header">
            <!-- <h1>{{ data.title }}</h1> -->
            <h1>{{data.title}}</h1>
            <p v-html="data.description"></p>
        </header>

        <div class="surver_box">
          
            <div class="surver_box_1">



                <div class="surver_4" v-for="(item,index) in filteredQuestions" :key="index" v-if="item.isShow=='Y'">
                    <div class="surver_4_1">
                        <p class="surver_4_1_1">{{ index+1 }}</p>
                        <span style="color: red;" v-if="item.required!='N'">* </span>
                         <p class="surver_4_1_2">
                            {{item.content}}
                            
                            <!-- ({{ item.questionType=='2' ?'单选' :item.questionType=='3' ?'多选' :item.questionType=='4' ?'问答':'' }}) -->
                        </p>
                    </div>
                    <!-- 单选 -->
                    <el-radio-group v-model="item.answer" class="surver_4_2" v-if="item.questionType=='2' ">
                        <div v-for="(item1, index2) in item.options" class="surver_4_2_1">
                            <el-radio class="surver_4_2_1_1" @change="updateAnswer(item, item1)" :key="index2"
                                :label="item1.surveyQuestionOptionId">{{checkbox[index2]}}、{{ item1.content }}
                            </el-radio>
                            <div class="surver_bottom_1"
                                v-if="item1.isOther=='Y'&&item.answer==item1.surveyQuestionOptionId">
                                <el-input type="textarea" :rows="2" v-model="item1.answerText" maxlength="1000"
                                    show-word-limit placeholder="请描述贵单位情况">
                                </el-input>
                            </div>
                        </div>
                    </el-radio-group>
                    <!-- 多选 -->
                    <el-checkbox-group v-model="item.answer" class="surver_4_3" v-if="item.questionType=='3'">
                        <div v-for="(item1, index2) in item.options" class="surver_4_2_2">
                            <div class="surver_4_2_2_1">
                                <el-checkbox @change="updateAnswer(item, item1)" :key="index2"
                                    :label="item1.surveyQuestionOptionId">
                                    {{checkbox[index2]}}、{{ item1.content }}
                                </el-checkbox>
                            </div>

                            <div class="surver_bottom_1" v-if="item1.isOther=='Y'">
                                <div v-for="(item3, index3) in item.answer" v-if="item3==item1.surveyQuestionOptionId">
                                    <el-input type="textarea" maxlength="1000" show-word-limit :rows="2"
                                        v-model="item1.answerText" placeholder="请描述贵单位情况">
                                    </el-input>
                                </div>

                            </div>
                        </div>
                    </el-checkbox-group>
                    <!-- 问答 -->
                    <!-- 多行 -->
                    <div v-if="item.questionType=='4'&&item.style==3" class="surver_4_4">
                        <el-input maxlength="1000" show-word-limit class="surver_4_4_1" type="textarea" :rows="6"
                            v-model="item.answerTextwd" placeholder=""></el-input>
                    </div>
                    <!-- 单行 -->
                    <div class="surver_4_4" v-if="item.questionType=='4'&&item.style==4">
                        <el-input maxlength="1000" class="surver_4_4_1" v-model="item.answerTextwd" placeholder="">
                        </el-input>
                    </div>
                    <!-- 选择 -->
                    <div v-if="item.questionType=='4'&&item.style==2" class="surver_4_4">
                        <el-select style="width:100%" v-model="item.answerTextwd" placeholder="请选择">
                            <el-option v-for="(item,index) in dicList" :key="index" :label="item.dictValue"
                                :value="item.dictValue">
                            </el-option>
                        </el-select>
                    </div>

                </div>
                <div class="submit-container">
                    <el-button @click="submitQuestion">提交问卷</el-button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import "@/assets/css/questionnaire.less"
    export default {

        name: "questionnaire",
        data() {
            //这里存放数据
            return {
                userData: {
                    companyName: "",
                    companyType: ""
                },
                code: null,
                loading: true,
                data: {
                    questions: []
                },
                checkbox: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
                    'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
                ],
                scoreNumk: 0,
                values: "",
                value2: null,
                checkedItems: [],
                dicList: []
            };
        },
        computed: {
            filteredQuestions() {
                return this.data.questions.filter(item => item.isShow === 'Y');
            }
        },
        components: {},
        watch: {
            // value2
        },
        //方法集合    
        methods: {
            // 字典
            zidian() {
                var _this = this
                _this.$api.dictlist({
                    dictKey: 'work_address'
                }).then(res => {
                    if (res.code == 200) {
                        this.dicList = res.data
                    } else {
                        _this.$message.error(res.msg);
                    }
                }).catch(function (error) {
                    _this.$message.error(error.msg);
                });
            },
            // 提交问卷
            submitQuestion() {
                var _this = this;
                // if (this.userData.companyName == '') {
                //     this.$message.error('请填写单位名称');
                //     return false
                // }
                // if (this.userData.companyType == '') {
                //     this.$message.error('请选择单位属性');
                //     return false
                // }
                var list = []
                for (var i = 0; i < this.data.questions.length; i++) {
                    if (this.data.questions[i].isShow == 'Y') {
                        if (this.data.questions[i].required != 'N') {
                            if (this.data.questions[i].questionType == 2 && this.data.questions[i].answer == '') {
                            this.$message.error('请填写所有问卷信息');
                                return false
                            }
                            if (this.data.questions[i].questionType == 3 && this.data.questions[i].answer == []) {
                                this.$message.error('请填写所有问卷信息');
                                return false
                            }
                            if (this.data.questions[i].questionType == 4 && this.data.questions[i].answerTextwd == '') {
                                this.$message.error('请填写所有问卷信息');
                                return false
                            }
                        }
                        
                    }
                    var answers = []
                    if (this.data.questions[i].isShow == 'Y') {

                        // 单选
                        if (this.data.questions[i].questionType == 2) {
                            if (this.data.questions[i].answer) {
                                for (var j = 0; j < this.data.questions[i].options.length; j++) {
                                    if (this.data.questions[i].options[j].surveyQuestionOptionId == this.data.questions[
                                            i]
                                        .answer) {
                                        answers.push({
                                            surveyQuestionOptionId: this.data.questions[i].answer,
                                            answerText: this.data.questions[i].options[j].answerText,
                                        })
                                    }
                                }
                            }
                        }
                        // 多选
                        if (this.data.questions[i].questionType == 3) {
                            const currentAnswerArray = this.data.questions[i].answer;
                            const optionsArray = this.data.questions[i].options;
                            for (var j = 0; j < currentAnswerArray.length; j++) {
                                const currentAnswer = currentAnswerArray[j];
                                for (var k = 0; k < optionsArray.length; k++) {
                                    const currentOption = optionsArray[k];
                                    if (currentAnswer === currentOption.surveyQuestionOptionId) {
                                        answers.push({
                                            surveyQuestionOptionId: currentAnswer,
                                            answerText: currentOption.answerText
                                        });
                                    }
                                }
                            }
                        }
                        // 问答
                        if (this.data.questions[i].questionType == 4) {
                            answers.push({
                                surveyQuestionOptionId: '',
                                answerText: this.data.questions[i].answerTextwd,
                            })
                        }
                        list.push({
                            surveyQuestionId: this.data.questions[i].surveyQuestionId,
                            answers: answers
                        })
                    }

                }
                console.log(list);
                var userTempID1 = null
                var userTempID = localStorage.getItem('userTempID');
                if (userTempID != undefined) {
                    userTempID1 = localStorage.getItem('userTempID');
                } else {
                    userTempID1 = this.data.userTempID
                }
                var obj = {
                    surveyId: this.data.surveyId,
                    userData: {
                        companyName: this.userData.companyName,
                        companyType: this.userData.companyType
                    },
                    userTempID: userTempID1,
                    questions: list
                }
                console.log(obj.list);

                _this.$api.surveySubmit(obj).then(res => {
                    if (res.code == 200) {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        this.$router.push('/questionnaire_success');
                    } else {
                        _this.$message.error(res.msg);
                    }
                }).catch(function (error) {
                    _this.$message.error(error.msg);
                });
            },
            // 更新答案
            updateAnswer(data, item, type) {
                for (var i = 0; i < this.data.questions.length; i++) {
                    // 查找是否有规则
                    if (this.data.questions[i].rules.length != 0) {
                        console.log(this.data.questions[i].rules, '有规则');
                        var b = -1;

                        for (var j = 0; j < this.data.questions[i].rules.length; j++) {

                            // console.log(item.surveyQuestionId,'题id');
                            // console.log(item.surveyQuestionOptionId,'题选项id');
                            console.log(this.data.questions[i].rules[j].sourceQuestionId, '依赖谁的选项id');
                            // console.log(this.data.questions[i].rules[j].triggerOptionId,'哪个选项触发');
                            // console.log(this.data.questions[i].rules[j].triggerType,'触发类型');
                            // console.log(this.data.questions[i].rules[j].targetQuestionId,'当前规则的试题id');
                            // console.log('-------------------------------------------------------------');
                            var operator = this.data.questions[i].rules[j].operator;
                            console.log(operator, 'operator');
                            //获取sourceQuestionId对应用户选项
                            var questionId = this.data.questions[i].rules[j].sourceQuestionId;
                            for (var m = 0; m < this.data.questions.length; m++) {

                                var mm = this.data.questions[m];

                                if (questionId == mm.surveyQuestionId) {
                                    b = 0;
                                    if (mm.questionType == 2) {

                                        if (mm.answer == this.data.questions[i].rules[j].triggerOptionId) {
                                            b = 1;
                                        }
                                    }
                                    if (mm.questionType == 3) {
                                        if (mm.answer) {
                                            for (var k = 0; k < mm.answer.length; k++) {
                                                if (mm.answer[k] == this.data.questions[i].rules[j].triggerOptionId) {
                                                    b = 1;
                                                }
                                            }
                                        }
                                    }

                                }

                            }
                            if (b == 1 && operator == "or") {
                                //    if (questionId == 17) {
                                //         debugger;
                                //     } 
                                break;
                            }

                            if (b == 0 && operator == "and") {

                                break;
                            }

                        }

                        if (b == 1) {
                            this.data.questions[i].isShow = 'Y'
                        } else {
                            if (b == 0) {
                                this.data.questions[i].isShow = 'N'
                                if (this.data.questions[i].questionType == 2) {
                                    this.data.questions[i].answer = ''
                                }
                                if (this.data.questions[i].questionType == 3) {
                                    this.data.questions[i].answer = []
                                }
                            }

                        }

                    }
                }
            },
            surveyinfo() {
                var _this = this;
                var code = this.code
                var userTempID1 = null
                var userTempID = localStorage.getItem('userTempID');
                if (userTempID != undefined) {
                    userTempID1 = localStorage.getItem('userTempID');
                } else {}
                _this.$api.surveyinfo({
                    code: code,
                    userTempID: userTempID1
                }).then(res => {
                    if (res.code == 200) {
                        this.data = res.data;
                        localStorage.setItem('userTempID', this.data.userTempID);
                        this.data.questions = this.data.questions.map(question => {
                            question.options = question.options.map(option => ({
                                ...option,
                                answerText: ''
                            }))
                            if (question.questionType == 2) {
                                return {
                                    ...question,
                                    answer: ''
                                };
                            }
                            if (question.questionType == 3) {
                                return {
                                    ...question,
                                    answer: []
                                };
                            }
                            if (question.questionType == 4) {
                                return {
                                    ...question,
                                    answer: [],
                                    answerTextwd: ""
                                };
                            }
                        });
                        console.log(this.data, '详情');
                        this.loading = false

                    } else if (res.code == 501) {
                        this.$router.push('/questionnaire_error?name=' + res.msg);
                    } else {
                        _this.$message.error(res.msg);
                    }
                }).catch(function (error) {
                    _this.$message.error(error.msg);
                });
            },
        },
        created() {},
        mounted() {
             document.title='调查问卷'
            this.zidian()
            if (this.$route.params.code != undefined) {
                this.code = this.$route.params.code
                // if(window.innerWidth<768){
                //     this.$router.push('/questionnaireH5/'+this.code);
                // }else{
                //     this.surveyinfo()
                // }
                this.surveyinfo()
            } else {
                this.code = 1
                this.surveyinfo()
            }
        },
    };
</script>
<style scoped lang="less">
    .surver_4_2_1_1_b {
        margin-bottom: 15px;
    }

    .radio-group {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        gap: 15px;
    }

    .input-group {
        margin-bottom: 25px;
    }

    .org-info {
        padding: 0 25px;
        background: var(--light-bg);
        border-radius: 8px;
        margin-bottom: 30px;
    }

    .org-info label {
        font-weight: 600;
        color: var(--primary-color);
    }

    ::v-deep .el-radio__original {
        display: none !important;
    }

    ::v-deep .el-radio-group {
        width: 100%;
        // display: grid;
        // grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        // gap: 15px;

    }

    ::v-deep .el-radio {
        width: 97%;
        display: flex;
        align-items: center;
        padding: 15px;
        background: #f8faff;
        border-radius: 8px;
        border: 1px solid #e0e4e9;
        transition: all 0.2s ease;
        position: relative;
    }

    ::v-deep .el-radio:hover {
        background: var(--accent-color);
        border-color: var(--secondary-color);
    }

    ::v-deep .el-textarea__inner {
        width: 100%;
        padding: 12px 18px;
        border: 2px solid #e0e4e9;
        border-radius: 8px;
        transition: all 0.3s ease;
        font-size: 15px;
    }

    ::v-deep .el-textarea__inner:focus {
        border-color: var(--secondary-color);
        box-shadow: 0 0 0 3px var(--accent-color);
        outline: none;
    }

    ::v-deep .el-button {
        background: var(--secondary-color);
        color: white;
        padding: 16px 50px;
        border: none;
        border-radius: 8px;
        font-size: 1.1em;
        cursor: pointer;
        transition: all 0.2s ease;
        letter-spacing: 1px;
        box-shadow: 0 4px 12px rgba(65, 121, 210, 0.3);
    }

    ::v-deep .is-checked {
        .el-radio__inner {
            width: 18px;
            height: 18px;
            background: var(--secondary-color);
        }

        .el-checkbox__label {
            color: var(--secondary-color);
        }

        .el-checkbox__inner {
            width: 18px;
            height: 18px;
            background: var(--secondary-color);
        }

        .el-radio__label {
            color: var(--secondary-color);
        }
    }

    ::v-deep .el-checkbox__inner::after {
        width: 5px;
        top: 3px;
    }

    ::v-deep .el-checkbox__inner {
        width: 18px;
        height: 18px;
    }

    ::v-deep .el-radio__inner {
        width: 18px;
        height: 18px;
    }

    @media (max-width: 768px) {
        ::v-deep .el-textarea__inner {
            padding: 10px 15px;
            font-size: 14px;
        }

        ::v-deep .el-button {
            padding: 12px 30px;
            font-size: 1em;
        }
    }

    @media (max-width: 768px) {
        .container {
            max-width: 100vw !important;
        }

        .questionnaire {
            padding: 20px 15px;

            .questionnaire-header {
                padding: 30px 10px 20px;

                h1 {
                    text-align: center;

                    font-size: 1.8em;
                }

                p {

                    font-size: 0.9em;
                }
            }

            .surver_box {
                padding: 20px;

                .surver_box_1 {
                    .surver_4 {
                        padding: 20px 0;

                        .surver_4_1 {
                            font-size: 1em;

                            .surver_4_1_1 {
                                width: 28px;
                                height: 28px;
                                line-height: 28px;
                                margin-right: 10px;
                            }

                            .surver_4_1_2 {
                                font-size: 1em;
                            }
                        }

                        .surver_4_2,
                        .surver_4_3,
                        .surver_4_4 {
                            margin-left: 0;
                        }

                        .surver_4_2_1,
                        .surver_4_2_2 {
                            margin-bottom: 10px;
                        }

                        .surver_bottom_1 {
                            margin-top: 15px;
                        }
                    }
                }
            }

            .submit-container {
                margin-top: 30px;
                padding: 20px 0;

                .el-button {
                    padding: 12px 30px;
                    font-size: 1em;
                }
            }
        }

        ::v-deep .el-radio {
            padding: 10px;
        }

        ::v-deep .el-textarea__inner {
            padding: 10px 15px;
            font-size: 14px;
        }
    }

    @media (max-width: 768px) {
        ::v-deep .el-radio-group {
            display: block;
        }

        ::v-deep .el-radio {
            width: 100%;
            margin-bottom: 10px;
        }
    }

    @media (max-width: 768px) {
        .questionnaire {
            .questionnaire-header {
                h1 {
                        text-align: center;

                    font-size: 1.8em;
                }

                p {

                    font-size: 0.9em;
                }
            }

            .surver_box {
                .surver_box_1 {
                    .surver_4 {
                        .surver_4_1 {
                            font-size: 1em;

                            .surver_4_1_1 {
                                width: 28px;
                                height: 28px;
                                line-height: 28px;
                                margin-right: 10px;
                            }

                            .surver_4_1_2 {
                                font-size: 1em;
                            }
                        }
                    }
                }
            }
        }
    }
</style>